import type { ListItem } from "@decocms/apps-commerce/types"

/**
 * Compare current array item with item from breadcrumb,
 *
 * if they are equals, return item from breadcrumb
 * else, return item from current array
 */
export default function (breadcrumb: ListItem<string>[], names: string[]) {
    const breadcrumbItems = breadcrumb.map(({ name }) => name).filter((x): x is string => !!x)
    const sanitizedBreadcrumbItems = breadcrumbItems.map((item) =>
        item
            .replace(/\s/g, '-')
            .toLowerCase()
            .normalize('NFD')
            .replace(/\p{Diacritic}/gu, '')
    )

    return names
        .map((i) => {
            const breadcrumbIndex = sanitizedBreadcrumbItems.indexOf(i.toLowerCase())

            if (breadcrumbIndex !== -1) {
                return breadcrumbItems[breadcrumbIndex]
            }

            return i
        })
        .map(decodeURIComponent)
}
